export default "__VITE_ASSET__Dx0w72bf__"